import { render, staticRenderFns } from "./yushen.vue?vue&type=template&id=d9bf8f02&scoped=true&"
import script from "./yushen.vue?vue&type=script&lang=js&"
export * from "./yushen.vue?vue&type=script&lang=js&"
import style0 from "./yushen.vue?vue&type=style&index=0&id=d9bf8f02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bf8f02",
  null
  
)

export default component.exports